module.exports = __webpack_public_path__ + "static/media/bluesappdp.78f7aec4.jpg";